<template>
    <div class="file-upload">
        <label class="label-label" for="upload-label">upload file</label>
        <input class="input-upload" id="file-upload" type="file" name="fileupload" value="fileupload" multiple data-multiple-caption="{count} files selected">
        <label id="upload-label" class="upload-label" for="file-upload">
            <div class="placeholder">
                <span>Upload a file</span>
            </div>
            <div class="button-primary">
                upload a file
            </div>
        </label>
    </div>
</template>

<script>
	
	export default {
		name: 'FileUpload'
	}
	
</script>